module.exports = __webpack_public_path__ + "static/media/agrosLogo.f2c87fa4.png";